import React from 'react';

const PrivacyPage = () => {
  return (
    <div className="doc-page privacy">
      <h1>プライバシーポリシー</h1>

      <p>Garlic Hamster（ガーリック・ハムスター、以下「当サイト」といいます。）は、ユーザーのプライバシーを尊重します。当サイトは、氏名や住所などの個人を直接特定できる情報（以下「個人情報」）を当サイト自体で収集・保存することは基本的に行いません。ただし、広告配信のために第三者（例：Google）のサービスがクッキーや端末識別子等を通じて非個人情報を収集する場合があります。</p>

      <h2>1. 個人情報の不収集・非保持</h2>
      <p>当サイトは、氏名、住所、電話番号、クレジットカード番号等の個人を直接特定できる情報を当サイト側で意図的に収集・保存することはありません（ユーザーが問い合わせ等で自発的に提供した場合を除く）。</p>

      <h2>2. 収集する情報</h2>
      <p>当サイトは次のような情報を収集・処理する場合があります（当サイト自体または第三者を通じて）</p>
      <ul>
        <li>端末情報（IP アドレス、ブラウザの種類、OS、言語設定）</li>
        <li>閲覧ログ（訪問日時、閲覧したページ、参照元 URL、滞在時間）</li>
        <li>クッキーや類似技術により取得される識別子（広告目的の識別子を含む）</li>
      </ul>

      <h2>3. 広告配信と第三者の利用</h2>
      <p>当サイトは、Google AdSense 等の広告配信サービスを利用しています。これら第三者は、広告配信および広告のパーソナライズ、効果測定のためにクッキーやウェブビーコン等を使用して情報を収集することがあります。Google によるデータ使用やオプトアウト等の詳細は、以下をご参照ください：</p>
      <ul>
        <li>Google の広告とプライバシー（英語/日本語）</li>
        <li>Google 広告の設定（オプトアウト）</li>
      </ul>

      <h2>4. クッキーの管理</h2>
      <p>ユーザーはブラウザの設定からクッキーを無効化することができます（ただし、その場合、広告表示や一部の機能に影響する可能性があります）。また、広告のパーソナライズを無効にするには、上記の Google 広告設定や各広告配信事業者のオプトアウトツールをご利用ください。</p>

      <h2>5. アクセス解析およびセキュリティ監視</h2>
      <p>当サイトでは、サービスの安定稼働および不正アクセスや悪用の検出・防止、アクセス状況の分析を目的として、アクセスログやリクエスト情報を収集・解析することがあります。収集する項目の例は以下のとおりです。</p>
      <ul>
        <li>リクエストのタイムスタンプ</li>
        <li>リクエストされたパスやステータスコード</li>
        <li>IP アドレス（匿名化して処理する場合があります）</li>
        <li>User-Agent や Referer 等のヘッダ情報</li>
      </ul>
      <p>これらのデータは、サービスの可用性確保、不正行為の検知、トラフィック傾向の把握のために利用され、必要な期間のみ保持されます。ログの保管先は当サイトのサーバーまたは CDN/クラウドサービス等の第三者事業者となる場合があります。これら第三者によるデータ処理は当該事業者のポリシーに従います。</p>

      <h2>6. 第三者提供とデータの販売に関する宣言</h2>
      <p>当サイトは、ユーザーの同意がある場合、または法令に基づく場合を除き、個人情報を第三者に販売・提供することはありません。業務委託先等に必要最小限の範囲で提供する場合には、適切な契約（機密保持契約等）を締結のうえ、必要な安全管理措置を講じます。</p>

      <h2>7. お問い合わせで提供された情報の取扱い</h2>
      <p>ユーザーがメール等で当サイトに連絡する際、氏名、メールアドレス、連絡先、住所、問い合わせ内容等の情報を任意で提供されることがあります（以下「お問い合わせ情報」）。当サイトは、以下の目的のためにお問い合わせ情報を利用します。</p>
      <ul>
        <li>お問い合わせへの回答および当該対応の履歴管理</li>
        <li>本人確認、対応状況の確認、必要に応じた追加連絡</li>
        <li>不具合の調査、改善、利用上の問題の解決</li>
        <li>法令に基づく対応や権利義務の履行</li>
      </ul>
      <p>当サイトは、上記目的の範囲を超えてお問い合わせ情報を利用することはなく、利用目的を変更する場合は事前に通知または本サイト上への掲示により周知します。</p>

      <h2>8. 保管期間</h2>
      <p>お問い合わせ情報は、原則としてお問い合わせ対応完了後から6か月以内を目安に削除または匿名化して保管します。ただし、法令により一定期間の保存が求められる場合や、ユーザーとの合意により別途保存する場合はその限りではありません。</p>

      <h2>9. 安全管理措置</h2>
      <p>当サイトは、お問い合わせ情報およびログデータの漏えい・滅失・毀損を防止するために、アクセス制御、通信の暗号化、ログ管理、権限管理等の合理的な安全管理措置を実施します。</p>

      <h2>10. 未成年者の取り扱い</h2>
      <p>未成年者（16 歳未満等）の保護者の同意が必要な情報の収集は行いません。保護者の方が当該情報の削除等を希望する場合は下記窓口までご連絡ください。</p>

      <h2>11. お問い合わせ</h2>
      <p>本ポリシーに関するお問い合わせは、下記までお願いいたします。対応に際しては、本人確認のための情報提供をお願いする場合があります。</p>
      <p>担当部署：個人情報担当窓口</p>
      <p>Eメールアドレス：contact@garlic-hamster.com</p>

      <h2>12. 本ポリシーの更新</h2>
      <p>本ポリシーは必要に応じて改訂されます。変更後の内容は本ページに掲載した時点で効力を生じます。</p>

      <p>最終更新日：2025年12月15日</p>
    </div>
  );
};

export default PrivacyPage;
